import script from "./RevenueStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenueStatistics.vue?vue&type=script&setup=true&lang=js"

import "./RevenueStatistics.vue?vue&type=style&index=0&id=7f01adb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f01adb2"]])

export default __exports__